export default function auth({ next, router }) {
  const session = localStorage.getItem('session') || sessionStorage.getItem('session')
  if (!session) {
    return next({ name: 'auth-login' });
  } else {
    const parsedSession = JSON.parse(session)
    const allowedRoles = [0, 1, 2, 4]

    if (!allowedRoles.includes(parsedSession.user.role)) {
      return next({ name: 'evaluations' })
    }
  }
  return next();
}
